<!-- Dashboard start -->
<!-- END: Left Aside -->
<div class="m-grid__item m-grid__item--fluid m-wrapper">
  <!-- BEGIN: Subheader -->
  <div class="m-subheader ">
    <div class="d-flex align-items-center"></div>
  </div>
  <!-- END: Subheader -->
  <!--MAIN-->
  <div class="m-content">
    <ngx-spinner
      bdColor="rgba(75, 55, 100, 0.5)"
      size="large"
      color="#fff"
      type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
    </ngx-spinner>

    <!--begin::Portlet-->
    <div class="m-portlet" style="width: 100%">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text" *ngIf="!editMode">
              CREATE NEW USER
            </h3>
            <h3 class="m-portlet__head-text" *ngIf="editMode">
              EDIT USER
            </h3>
          </div>
        </div>
      </div>
      <!--begin::Form-->
      <form [formGroup]="userForm" class="m-form m-form--label-align-right">
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Email:
              </label>
              <div class="col-lg-6">
                <input
                  formControlName="emailInput"
                  pattern='(?:[A-z0-9!#$%&amp;"*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&amp;"*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-z0-9](?:[A-z0-9-]*[A-z0-9])?\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[A-z0-9-]*[A-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])'
                  type="text"
                  id="email"
                  class="form-control m-input"
                  [(ngModel)]="userEmail"
                />
                <span
                  class="m-form__help"
                  style="color:red;"
                  *ngIf="
                    !userForm.controls.emailInput.valid &&
                    (userForm.controls.emailInput.dirty ||
                      userForm.controls.emailInput.touched)
                  "
                >
                  Please enter a valid email for this user
                </span>
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Phone Number
              </label>
              <div class="col-lg-6">
                <input
                  formControlName="phoneNumberInput"
                  type="text"
                  id="phonenumber"
                  pattern="^[\s.]*(\d{1,2}[\s.-]*)?\(?\d{3}\)?[\s.-]*\d{3}[\s.-]*\d{4}[\s.]*$"
                  maxlength="16"
                  class="form-control m-input"
                  [(ngModel)]="userPhoneNumber"
                />
                <span class="m-form__help">
                  A valid phone number is not required, but is recommended. </span
                ><br />
                <span
                  class="m-form__help"
                  style="color:red;"
                  *ngIf="
                    !userForm.controls.phoneNumberInput.valid &&
                    (userForm.controls.phoneNumberInput.dirty ||
                      userForm.controls.phoneNumberInput.touched)
                  "
                >
                  Please enter a valid phone number for this user
                </span>
              </div>
            </div>

            <div *ngIf="hasSiteMangement">
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, this date range will dictate the period of time that this user can create services"
                  />
                  Subscription Period:
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="enableSubsciptionPeriod"
                      formControlName="enableSubscriptionPeriodInput"
                      type="checkbox"
                      class="form-control"
                      (change)="toggleSubscription()"
                      [(ngModel)]="enableSubscription"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="col-lg-4">
                  <app-service-period
                    [minDays]="30"
                    [showTooltip]="false"
                    formControlName="period"
                  ></app-service-period>
                </div>
              </div>
  
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, after the user uploads a custom track he will be able to program the torches for it"
                  />
                  Can User Program Lightshows
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="canProgramCustomTracks"
                      formControlName="canProgramCustomTracks"
                      [(ngModel)]="canProgramCustomTracks"
                      type="checkbox"
                      class="form-control"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
  
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, this user will be able to create venues and add sections to their light shows"
                  />
                  Can User Edit Venues
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="canEditVenues"
                      formControlName="canEditVenues"
                      type="checkbox"
                      class="form-control"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
  
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, this user will be able to use the Global Sync feature"
                  />
                  Can User Start Global Sync
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="enableNetworkSync"
                      formControlName="enableNetworkSync"
                      [(ngModel)]="enableNetworkSync"
                      type="checkbox"
                      class="form-control" 
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
  
              <div *ngIf="!hasApiKey"  class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, this will create a user API key on create/update"
                  />
                  Create User API Key
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="createUserApiKey"
                      formControlName="createUserApiKey"
                      [(ngModel)]="createUserApiKey"
                      type="checkbox"
                      class="form-control" 
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
  
              <div *ngIf="hasApiKey" class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  Max API Invocations Per Day 
                </label>
                <div class="col-lg-2">
                  <input
                    formControlName="maxDailyRate"
                    type="number"
                    id="maxDailyRate"
                    class="form-control m-input"
                    [(ngModel)]="maxDailyRate"
                  />
                </div>
              </div>
            </div>
          

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Engine Application:
              </label>
              <div class="col-lg-6">
                <select
                  formControlName="engineIdSelect"
                  class="col-lg-12 col-m-4 form-control m-input"
                  id="userengine"
                  [(ngModel)]="selectedEngine"
                  name="engineIdSelect"
                >
                  <option style="display: none;" value="null"></option>
                  <option
                    *ngFor="let engine of engines"
                    [selected]="engine.engineId == selectedEngineId"
                    [ngValue]="engine"
                  >
                    {{ engine.applicationName }}
                  </option>
                </select>
                <span
                  class="m-form__help"
                  style="color:red;"
                  *ngIf="
                    !userForm.controls.engineIdSelect.valid &&
                    (userForm.controls.engineIdSelect.dirty ||
                      userForm.controls.engineIdSelect.touched)
                  "
                >
                  Please choose an engine application for this user
                </span>
              </div>
            </div>

            <div *ngIf="hasAllUsers" class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Organization:
              </label>
              <div class="col-lg-6">
                <select
                  [requiredIf]="hasAllUsers"
                  formControlName="organizationIdSelect"
                  class="col-lg-12 col-m-4 form-control m-input"
                  id="organization"
                  [(ngModel)]="selectedOrganization"
                  name="organization"
                  (change)="onSelectOrganization()"
                >
                  <option style="display: none;" value="null"></option>
                  <option
                    *ngFor="let org of organizations"
                    [selected]="org.organizationId === selectedOrganizationId"
                    [ngValue]="org"
                  >
                    {{ org.name }}
                  </option>
                </select>
                <span
                  class="m-form__help"
                  style="color:red;"
                  *ngIf="
                    !userForm.controls.organizationIdSelect.valid &&
                    (userForm.controls.organizationIdSelect.dirty ||
                      userForm.controls.organizationIdSelect.touched)
                  "
                >
                  Please choose an organization for this user
                </span>
              </div>
            </div>

            <div
              class="form-group m-form__group row"
              [hidden]="selectedOrganization == null || loading"
            >
              <label class="col-lg-4 col-form-label">
                Client Type:
              </label>
              <div class="col-lg-6">
                <select
                  formControlName="clientTypeIdSelect"
                  class="col-lg-12 col-m-4 form-control m-input"
                  id="clienttype"
                  [(ngModel)]="selectedClientType"
                  name="selectedClientType.name"
                >
                  <option style="display: none;" value="null"></option>
                  <option
                    *ngFor="let type of clientTypes"
                    [selected]="type.clientTypeId == selectedClientTypeId"
                    [ngValue]="type"
                  >
                    {{ type.name }} / {{ type.code }}
                  </option>
                </select>
                <span
                  class="m-form__help"
                  style="color:red;"
                  *ngIf="
                    !userForm.controls.clientTypeIdSelect.valid &&
                    (userForm.controls.clientTypeIdSelect.dirty ||
                      userForm.controls.clientTypeIdSelect.touched)
                  "
                >
                  Please choose a client type for this user
                </span>           
              </div>
            </div>

            <div
              *ngIf="(hasAllUsers || hasOrgUsers) && !staffUser"
              class="form-group m-form__group row"
            >
              <label class="col-lg-4 col-form-label">
                Role:
              </label>
              <div class="col-lg-6">
                <select
                  [requiredIf]="(hasAllUsers || hasOrgUsers) && !staffUser"
                  formControlName="roleIdSelect"
                  class="col-lg-12 col-m-4 form-control m-input"
                  id="role"
                  [(ngModel)]="selectedRole"
                  name="role"
                >
                  <option style="display: none;" value="null"></option>
                  <option
                    style="color:black;"
                    [selected]="role.roleId == selectedRoleId"
                    *ngFor="let role of roles"
                    [ngValue]="role"
                  >
                    {{ role.name }}
                  </option>
                </select>
                <span class="m-form__help" style="color:red;"
                *ngIf="selectedRole && selectedRole.name ==='Admin' && 
                (userForm.controls.roleIdSelect.dirty || 
                userForm.controls.roleIdSelect.touched)">
                  Are you sure this user should be an Admin?  
                </span>
                <span
                  class="m-form__help"
                  style="color:red;"
                  *ngIf="
                    !userForm.controls.roleIdSelect.valid &&
                    (userForm.controls.roleIdSelect.dirty ||
                      userForm.controls.roleIdSelect.touched)
                  "
                >
                  Please choose a role for this user
                </span>
              </div>
            </div>

            <div class="form-group m-form__group row" *ngIf="!editMode">
              <label class="col-lg-4 col-form-label">
                Notify the user via email:
              </label>
              <div class="col-lg-6">
                <label class="switch">
                  <input
                    formControlName="shouldNotifyUserCreatedInput"
                    id="shouldNotifyUserCreated"
                    type="checkbox"
                    class="form-control"
                    [(ngModel)]="shouldNotifyUserCreated"
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
          <!--end::Portlet-->
        </div>
      </form>
    </div>

    <div class="form-group m-form__group row">
      <div class="col-lg-6">
        <div class="col-lg-4"></div>
        <div class="col-lg-8">
          <!-- [disabled]="!userForm.valid || loading" -->
          <button type="button" class="btn btn-info" (click)="submitUser()">
            <span *ngIf="!editMode">Create User</span>
            <span *ngIf="editMode">Update User</span>
          </button>
          <button type="submit" (click)="cancel()" class="btn btn-danger">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
